import set from 'lodash/set'

export const TRANSLATION = Symbol()
export function tr(t: any) {
  t[TRANSLATION] = true
  return t
}

export function makeTranslations(t: any): any {
  const made = {}

  function recpost(lang: string, t: any, path: string[]) {
    if (!t || typeof t === 'string') {
      set(made, [lang, ...path], t)
    } else {
      for (const [k, v] of Object.entries(t)) {
        set(made, [lang, ...path.slice(0, path.length - 1), `${path[path.length - 1]}_${k}`], v)
      }
    }
  }

  function recpre(t: any, path: string[]) {
    if (t[TRANSLATION]) {
      for (const [lang, v] of Object.entries(t) as any) {
        recpost(lang, v, [...path])
      }
    } else {
      for (const [k, v] of Object.entries(t) as any) {
        recpre(v, [...path, k])
      }
    }
  }

  recpre(t, [])

  return made
}
